module.exports = __webpack_public_path__ + "img/temp_logo.dd794545.png";